'use client';
class TimeoutError extends Error {
    constructor(request){
        super('Истекло время запроса');
        this.name = 'TimeoutError';
        this.request = request;
        Object.setPrototypeOf(this, TimeoutError.prototype);
    }
}

export { TimeoutError };
//# sourceMappingURL=TimeoutError.js.map
